import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const Results = styled.div`
  position: absolute;
  top: 100%;
  margin: 0.25rem auto;
  z-index: 1;
  background-color: #fff;
  width: 100%;
  border: ${(props) => props.theme.border};
  border-radius: 0.5rem;
  box-shadow: 0px 2px 24px -6px rgba(18, 38, 63, 0.075);
  overflow-y: auto;
  transition: height 0.25s, opacity 0.125s;

  height: 0;
  opacity: 0;
  visibility: hidden;

  ${(props) =>
    props.isVisible &&
    css`
      height: auto;
      max-height: 16rem;
      opacity: 1;
      visibility: visible;
    `}

  > ul {
    min-height: 12rem;
  }
`

export const ResultsFooter = styled.div`
  background-color: ${(props) => props.theme.background};

  height: 3.5rem !important;

  padding: 0 1rem;
  position: sticky;

  display: flex;
  align-items: center;
  justify-content: stretch;

  box-shadow: 0px -2px 4px rgba(0, 24, 45, 0.05);

  bottom: 0;
`
